import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.stepAppsureBankDetails.sectionTitle',
    defaultMessage: 'Section 10 - Bank Details',
  },
  whatIsYourABN: {
    id: 'fastCover.stepAppsureBankDetails.whatIsYourABN',
    defaultMessage: 'What is your Australian Business Number (ABN)?',
  },
  claimITC: {
    id: 'fastCover.stepAppsureBankDetails.claimITC',
    defaultMessage: 'Have you claimed or are you entitled to claim an Input Tax Credit (ITC) in respect to the GST paid on the insurance policy under which this claim is being made?',
  },
  whatPercentageOfGST: {
    id: 'fastCover.stepAppsureBankDetails.whatPercentageOfGST',
    defaultMessage: 'What percentage of GST did you claim or are entitled to claim?',
  },
  yes: {
    id: 'fastCover.stepAppsureBankDetails.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepAppsureBankDetails.no',
    defaultMessage: 'No',
  },
  weCannotDepositIntoACreditCardAccount: {
    id: 'fastCover.stepAppsureBankDetails.weCannotDepositIntoACreditCardAccount',
    defaultMessage: 'We cannot deposit into a credit card account or overseas bank account.',
  },
  paymentRequiredMessage: {
    id: 'fastCover.stepAppsureBankDetails.paymentRequiredMessage',
    defaultMessage: 'If we are required to make a payment on your behalf, no payment will be made until we receive payment from you of any applicable excess.',
  },
  nameOfBank: {
    id: 'fastCover.stepAppsureBankDetails.nameOfBank',
    defaultMessage: 'Name of Bank',
  },
  branch: {
    id: 'fastCover.stepAppsureBankDetails.branch',
    defaultMessage: 'Branch Name',
  },
  bsbNumber: {
    id: 'fastCover.stepAppsureBankDetails.bsbNumber',
    defaultMessage: 'BSB Code',
  },
  accountNumber: {
    id: 'fastCover.stepAppsureBankDetails.accountNumber',
    defaultMessage: 'Account Number',
  },
  accountNumberNZ: {
    id: 'fastCover.stepAppsureBankDetails.accountNumberNZ',
    defaultMessage: 'Account Number and Suffix',
  },
  accountNumberNZPlaceholder: {
    id: 'fastCover.stepAppsureBankDetails.accountNumberNZPlaceholder',
    defaultMessage: 'E.g. 1234567000',
  },
  bsbNumberNZTooltip: {
    id: 'fastCover.stepAppsureBankDetails.bsbNumberNZTooltip',
    defaultMessage:
      'The first 6 digits of your bank account which captures your bank’s prefix and branch number (e.g. 123113).',
  },
  accountNumberNZTooltip: {
    id: 'fastCover.stepAppsureBankDetails.accountNumberNZTooltip',
    defaultMessage: 'Your unique number and suffix (usually 9-10 digits)',
  },
  accountHolder: {
    id: 'fastCover.stepAppsureBankDetails.accountHolder',
    defaultMessage: 'Name Listed On Account',
  },
  accountNamePlaceholder: {
    id: 'fastCover.stepAppsureBankDetails.accountNamePlaceholder',
    defaultMessage: 'Account holder’s full name.',
  },
  GSTInfo: {
    id: 'fastCover.stepAppsureBankDetails.GSTInfo',
    defaultMessage: 'GST information - applicable if your policy was purchased for a business',
  },
  areYouRegisteredForGTSPurposes: {
    id: 'fastCover.stepAppsureBankDetails.areYouRegisteredForGTSPurposes',
    defaultMessage: 'Are you registered for GST Purposes?',
  },
  pleaseNote: {
    id: 'fastCover.stepAppsureBankDetails.pleaseNote',
    defaultMessage: 'Please note',
  },
  depositMessage: {
    id: 'fastCover.stepAppsureBankDetails.depositMessage',
    defaultMessage: 'If your claim is approved and where a cash settlement applies, we will deposit your settlement directly into your nominated bank account.',
  },
  bsbNumberLengthValidation: {
    id: 'fastCover.stepAppsureBankDetails.bsbNumberLengthValidation',
    defaultMessage: '{type} must be equal to 6 characters',
  },
  bsbCannotBeVerified: {
    id: 'fastCover.stepAppsureBankDetails.bsbCannotBeVerified',
    defaultMessage: 'BSB cannot be verified',
  },
  notice: {
    id: 'fastCover.stepAppsureBankDetails.notice',
    defaultMessage: 'The BSB Number you have entered could not be verified.',
  },
  noticeIntruction: {
    id: 'fastCover.stepAppsureBankDetails.noticeIntruction',
    defaultMessage: 'To continue any way, please tick the checkbox and manually enter the remaining fields.',
  },
  invalidBSBWarning: {
    id: 'fastCover.stepAppsureBankDetails.invalidBSBWarning',
    defaultMessage: 'The entered BSB number is not found in our records, tick the checkbox in order to successfully submit the claim.',
  },
  doYouHaveAnotherOtherInsurance: {
    id: 'fastCover.stepAppsureBankDetails.doYouHaveAnotherOtherInsurance',
    defaultMessage:
      'Do you have any other insurance that would cover all or part of your loss?',
  },
  exampleHomeContentsInsurance: {
    id: 'fastCover.stepAppsureBankDetails.exampleHomeContentsInsurance',
    defaultMessage:
      'e.g. Home Contents insurance, Private Health Fund, Credit Card',
  },
  ifYesPleaseProvideDetails: {
    id: 'fastCover.stepAppsureBankDetails.ifYesPleaseProvideDetails',
    defaultMessage: 'If yes, please provide details',
  },
  isRequired: {
    id: 'fastCover.stepAppsureBankDetails.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  noticeNZ: {
    id: 'fastCover.stepAppsureBankDetails.noticeNZ',
    defaultMessage: 'The Bank Code you have entered could not be verified.',
  },
  bsbNumberNZ: {
    id: 'fastCover.stepAppsureBankDetails.bsbNumberNZ',
    defaultMessage: 'Bank and Branch Code',
  },
  bsbNumberNZPlaceholder: {
    id: 'fastCover.stepAppsureBankDetails.bsbNumberNZPlaceholder',
    defaultMessage: 'E.g. 123456',
  },
  bsbCannotBeVerifiedNZ: {
    id: 'fastCover.stepAppsureBankDetails.bsbCannotBeVerifiedNZ',
    defaultMessage: 'Bank Code cannot be verified',
  },
  bankAccountNameTooltip: {
    id: 'fastCover.stepAppsureBankDetails.bankAccountNameTooltip',
    defaultMessage: 'The bank account holder\'s name.',
  },
  limitAccountNameCharacters: {
    id: 'fastCover.stepAppsureBankDetails.limitAccountNameCharacters',
    defaultMessage: 'The Name Listed On Account must be less than or equal to 32 characters',
  },
  onlyAlphaHyphenAllowed: {
    id: 'app.containers.StepAppsureBankDetails.onlyAlphaHyphenAllowed',
    defaultMessage: 'Only alphabetical characters and hyphens are allowed',
  },
  accountNumberLengthValidation: {
    id: 'app.containers.StepAppsureBankDetails.accountNumberLengthValidation',
    defaultMessage: 'The account number must not exceed {maxLength} digits.',
  },
  accountNumberLengthValidationWithSuffix: {
    id: 'app.containers.StepAppsureBankDetails.accountNumberLengthValidationWithSuffix',
    defaultMessage: 'Please enter your account number, including the suffix.',
  },
  accountNumberNZLengthValidationWithSuffix: {
    id: 'app.containers.StepAppsureBankDetails.accountNumberLengthValidationWithSuffix',
    defaultMessage: 'Your account number must contain 7 digits, and your suffix either 2 or 3 digits.',
  },
  accountHoldersName: {
    id: 'fastCover.stepAppsureBankDetails.accountHoldersName',
    defaultMessage: 'Account Holder’s Name',
  },
  onlyAlphaCharactersAllowed: {
    id: 'fastCover.stepAppsureBankDetails.onlyAlphaCharactersAllowed',
    defaultMessage: 'Only alphabetical characters are allowed.',
  },
  transitNumber: {
    id: 'fastCover.stepAppsureBankDetails.transitNumber',
    defaultMessage: 'Transit Number',
  },
  transitNumberValidation: {
    id: 'fastCover.stepAppsureBankDetails.transitNumberValidation',
    defaultMessage: 'Please enter the 5-digit Transit Number',
  },
  institutionNumber: {
    id: 'fastCover.stepAppsureBankDetails.institutionNumber',
    defaultMessage: 'Institution Number',
  },
  institutionNumberValidation: {
    id: 'fastCover.stepAppsureBankDetails.institutionNumberValidation',
    defaultMessage: 'Please enter the 3-digit Institution Number',
  },
  transitNumberTooltip: {
    id: 'fastCover.stepAppsureBankDetails.transitNumberTooltip',
    defaultMessage: '5-digit number that identifies your bank branch',
  },
  institutionNumberTooltip: {
    id: 'fastCover.stepAppsureBankDetails.institutionNumberTooltip',
    defaultMessage: '3-digit number that identifies your financial institution',
  },
  transitAndInstitutionCannotBeVerified: {
    id: 'fastCover.stepAppsureBankDetails.transitAndInstitutionCannotBeVerified',
    defaultMessage: 'Transit and Institution Number cannot be verified',
  },
  transitAndInstitutionNotice: {
    id: 'fastCover.stepAppsureBankDetails.transitAndInstitutionNotice',
    defaultMessage:
      'The Transit Number and Institution Number you have entered could not be verified.',
  },
  routingNumberNotice: {
    id: 'fastCover.stepAppsureBankDetails.routingNumberNotice',
    defaultMessage: 'The Transit and Institution Number you have entered could not be verified.',
  },
  swiftNotice: {
    id: 'fastCover.stepAppsureBankDetails.swiftNotice',
    defaultMessage: 'The SWIFT you have entered could not be verified.',
  },
  accountNumberMinValidation: {
    id: 'fastCover.stepAppsureBankDetails.accountNumberMinValidation',
    defaultMessage: 'Please enter minimum of 7 digits.',
  },
  accountNumberMaxValidation: {
    id: 'fastCover.stepAppsureBankDetails.accountNumberMaxValidation',
    defaultMessage: 'Please enter maximum of 12 digits.',
  },
  // V2 messages
  paymentOptions: {
    id: 'fastCover.stepAppsureBankDetails.paymentOptions',
    defaultMessage: 'Payment Options',
  },
  paymentTo: {
    id: 'fastCover.stepAppsureBankDetails.paymentTo',
    defaultMessage: 'Payment To',
  },
  memberInsured: {
    id: 'fastCover.stepAppsureBankDetails.memberInsured',
    defaultMessage: 'Member / Insured',
  },
  familyMember: {
    id: 'fastCover.stepAppsureBankDetails.familyMember',
    defaultMessage: 'Family Member',
  },
  provider: {
    id: 'fastCover.stepAppsureBankDetails.provider',
    defaultMessage: 'Provider',
  },
  country: {
    id: 'fastCover.stepAppsureBankDetails.country',
    defaultMessage: 'Country',
  },
  bankTypeCode: {
    id: 'fastCover.stepAppsureBankDetails.bankTypeCode',
    defaultMessage: 'Bank Type Code',
  },
  bankCode: {
    id: 'fastCover.stepAppsureBankDetails.bankCode',
    defaultMessage: 'Bank Code',
  },
  swiftCode: {
    id: 'fastCover.stepAppsureBankDetails.swiftCode',
    defaultMessage: 'Swift Code',
  },
  IBANText: {
    id: 'fastCover.stepAppsureBankDetails.IBAN',
    defaultMessage: 'IBAN',
  },
  bankCodeOrRoutingNumber: {
    id: 'fastCover.stepAppsureBankDetails.bankCodeOrRoutingNumber',
    defaultMessage: 'Bank Code / Routing Number',
  },
  bankAccountName: {
    id: 'fastCover.stepAppsureBankDetails.bankAccountName',
    defaultMessage: 'Name Listed On Account',
  },
  bankAccountNumber: {
    id: 'fastCover.stepAppsureBankDetails.bankAccountNumber',
    defaultMessage: 'Bank Account Number',
  },
  bankName: {
    id: 'fastCover.stepAppsureBankDetails.bankName',
    defaultMessage: 'Bank Name',
  },
  bankBranchName: {
    id: 'fastCover.stepAppsureBankDetails.bankBranchName',
    defaultMessage: 'Bank Branch Name',
  },
  bankAddress: {
    id: 'fastCover.stepAppsureBankDetails.bankAddress',
    defaultMessage: 'Bank Address',
  },
  bankSuburbOrCity: {
    id: 'fastCover.stepAppsureBankDetails.bankSuburbOrCity',
    defaultMessage: 'Bank Suburb/City',
  },
  bankPostcode: {
    id: 'fastCover.stepAppsureBankDetails.bankPostcode',
    defaultMessage: 'Bank Postcode',
  },
  isValidAccountNumber: {
    id: 'fastCover.stepAppsureBankDetails.isValidAccountNumber',
    defaultMessage: 'Bank Account Number maximum length needs to be 17 characters or less',
  },
  isValidBankCode: {
    id: 'fastCover.stepAppsureBankDetails.isValidBankCode',
    defaultMessage: 'Bank Code / Routing Number maximum length needs to be 32 characters or less',
  },
  isValidSwiftCode: {
    id: 'fastCover.stepAppsureBankDetails.isValidSwiftCode',
    defaultMessage: 'Swift code maximum length needs to be 11 characters or less',
  },
  isValidIban: {
    id: 'fastCover.stepAppsureBankDetails.isValidIban',
    defaultMessage: 'IBAN code maximum length needs to be 34 characters or less',
  },
  isValidBankAccountName: {
    id: 'fastCover.stepAppsureBankDetails.isValidBankAccountName',
    defaultMessage: 'Bank Name Listed On Account maximum length needs to be 128 characters or less',
  },
  reminderIban: {
    id: 'fastCover.stepAppsureBankDetails.reminderIban',
    defaultMessage: 'Contains two-letter country code, two check digits, followed by up to 35 letters/numbers (No spaces or dashes)',
  },
  isMaxLength: {
    id: 'fastCover.stepAppsureBankDetails.isMaxLength',
    defaultMessage: "'{defaultMessage}' maximum length has been exceeded",
  },
  isMinLength: {
    id: 'fastCover.stepAppsureBankDetails.isMinLength',
    defaultMessage: "'{defaultMessage}' must be at least {minLength} characters",
  },
  isOnlyDigits: {
    id: 'fastCover.stepAppsureBankDetails.isOnlyDigits',
    defaultMessage: "'{defaultMessage}' must contain digits only",
  },
  confirmSelectCountry: {
    id: 'fastCover.stepAppsureBankDetails.confirmSelectCountry',
    defaultMessage: 'If your country is not listed in the drop-down options, please change your payment method selection from EFT to Check.',
  },
  alternativelyText: {
    id: 'fastCover.stepAppsureBankDetails.alternativelyText',
    defaultMessage: 'Alternatively, if you wish to receive payment via check please select this checkbox. Payments made via check take longer to be processed while EFT payments are received faster.',
  },
  title: {
    id: 'fastCover.stepAppsureBankDetails.title',
    defaultMessage: 'Title',
  },
  firstName: {
    id: 'fastCover.stepAppsureBankDetails.firstName',
    defaultMessage: 'First Name',
  },
  lastName: {
    id: 'fastCover.stepAppsureBankDetails.lastName',
    defaultMessage: 'Last Name',
  },
  addressLine1: {
    id: 'fastCover.stepAppsureBankDetails.addressLine1',
    defaultMessage: 'Address Line 1',
  },
  addressLine2: {
    id: 'fastCover.stepAppsureBankDetails.addressLine2',
    defaultMessage: 'Address Line 2',
  },
  state: {
    id: 'fastCover.stepAppsureBankDetails.state',
    defaultMessage: 'State',
  },
  city: {
    id: 'fastCover.stepAppsureBankDetails.city',
    defaultMessage: 'City',
  },
  postalZipCode: {
    id: 'fastCover.stepAppsureBankDetails.postalZipCode',
    defaultMessage: 'Postal / Zip Code',
  },
  mobile: {
    id: 'fastCover.stepAppsureBankDetails.mobile',
    defaultMessage: 'Mobile',
  },
  checkAddress: {
    id: 'fastCover.stepAppsureBankDetails.checkAddress',
    defaultMessage: 'Check Address (if different then claimants address)',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Appsure.StepBankDetails/messages.js